import { render, staticRenderFns } from "./RtnInvoiceNew.vue?vue&type=template&id=5fcd094b&"
import script from "./RtnInvoiceNew.vue?vue&type=script&lang=js&"
export * from "./RtnInvoiceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports